/**
 * The repositories/branches product is being deprecated. The server enforces a
 * global `block_branch_creation` feature flag and rejects branch creation with
 * this stable, machine-readable code (HTTP 403 for REST, `extensions.code` for
 * GraphQL). We detect on this code rather than the human-readable message.
 */
export const BRANCH_CREATION_DISABLED_CODE = "BRANCH_CREATION_DISABLED";

/**
 * Link to the migration guide users should follow before the repositories
 * product is removed.
 */
export const REPOSITORIES_MIGRATION_GUIDE_URL =
  "https://codesandbox.io/docs/learn/repositories/migration-guide";

/**
 * User-facing copy shown when branch creation is blocked. Mirrors the wording
 * used by the dashboard (codesandbox-client) deprecation modal/banner.
 */
export const BRANCH_CREATION_DEPRECATED_MESSAGE =
  "Branch creation is deprecated. The repositories product will be removed on July 15th. Make sure to commit and push any work on your branches before then.";

/**
 * Returns true when an error (or error-like value) represents the
 * branch-creation deprecation. Detects the stable `code`, never the message.
 */
export function isBranchCreationDisabledError(error: unknown): boolean {
  if (!error || typeof error !== "object") {
    return false;
  }

  return (error as { code?: unknown }).code === BRANCH_CREATION_DISABLED_CODE;
}
